import is from '@sindresorhus/is';
import { createContext, type FunctionComponent, type PropsWithChildren, useContext } from 'react';

import { ChatComposerConversationContext } from '../chat-composer-contexts';
import { type LegacyChatConversation, useChatConversation } from './hooks/use-chat-conversation';

const LegacyChatConversationContext = createContext<LegacyChatConversation | null>(null);

export const LegacyChatConversationProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const conversation = useChatConversation();

    return (
        <LegacyChatConversationContext.Provider value={conversation}>
            <ChatComposerConversationContext.Provider value={conversation}>
                {children}
            </ChatComposerConversationContext.Provider>
        </LegacyChatConversationContext.Provider>
    );
};

export const useLegacyChatConversation = (): LegacyChatConversation => {
    const value = useContext(LegacyChatConversationContext);
    if (is.null(value)) {
        throw new Error('useLegacyChatConversation must be used within a LegacyChatConversationProvider');
    }
    return value;
};
